import { Transforms } from "slate";
export var insertVideo = function (editor, url) {
    var videoName = url.split("?v=")[1].split("&")[0];
    var text = { text: "" };
    var video = {
        type: "video",
        url: videoName,
        children: [text],
    };
    Transforms.insertNodes(editor, video);
};
